import React, { useState, useEffect } from "react";
import $ from "jquery";
import "datatables.net"; // Ensure DataTables is installed
import { RotatingLines } from "react-loader-spinner";
import { API } from "../../helper/Api";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/vendors/mdi/css/materialdesignicons.min.css";
import { useRole } from "../contextApi/RoleContext";

const Roles = () => {
  const { setRole, role, setPermission, permission,userDetails } = useRole();
  const [items, setItems] = useState([]);
  const [pending, setPending] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [storeCurrPerm, setStoreCurrPerm] = useState();
  const navigate = useNavigate();

  // Fetch data function
  const fetchData = async () => {
    try {
      let setId=role;
      if(userDetails.usertype.trim() === "CORP"){
        setId=0;
              }
      const res = await API.accessSetting("getuser",setId);
      if (res.success) {
        setPending(false);
        $("#myTable1").DataTable().destroy();

        setItems(res.content);
        console.log("Fetched roles:", res.content);
      } else {
        console.log("Error in fetching roles");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDelete = (id) => {
    setDeleteId(id); // Store the ID of the item to delete
    setShowModal(true); // Show the modal
  };

  const confirmDelete = async () => {
    console.log("Deleted item with id:", deleteId);
    setShowModal(false); // Close the modal after deletion
    try {
      const res = await API.accessSetting("deleteuserrole", deleteId);
      if (res.success) {
        fetchData();
      } else {
        console.log("Error in deleting role");
      }
    } catch (error) {
      console.error("Error deleting role:", error);
    }
  };

  const cancelDelete = () => {
    setShowModal(false); // Close the modal if the user cancels
  };

  // Initialize and update DataTable
  useEffect(() => {
    const table = $("#myTable1");
    // Destroy previous instance before reinitializing
    if ($.fn.dataTable.isDataTable("#myTable1")) {
      table.DataTable().clear().destroy();
    }

    if (items.length > 0) {
      API.DataTableScript();

      table.on("click", ".edit-role", function (e) {
        e.preventDefault();
        const id = $(this).data("id");
        navigate(`/edituser?id=${id}`);
      });
      // Add click event listener for delete buttons
      table.on("click", ".delete-role", function (e) {
        e.preventDefault();
        const id = $(this).data("id");
        handleDelete(id);
      });
    }
  }, [items]); // Run whenever `items` changes

  useEffect(() => {
    fetchData();
    const currentPagePerm = permission.find((item) => item.category_id === "9");
    setStoreCurrPerm(currentPagePerm);
  }, []); // Initial fetch on component mount
  return (
    <>
      <div className="container-fluid page-body-wrapper">
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="container" style={{ borderRadius: "3px" }}>
              {pending ? (
                <div className="loader">
                  <RotatingLines
                    visible={true}
                    height="96"
                    width="96"
                    strokeColor="grey"
                    strokeWidth="2"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                  />
                </div>
              ) : (
                <div>
                  {storeCurrPerm.add_permission === "1" ? (
                    <div className="button_list">
                      <div className="additembutton1">
                        <Link to="/adduser">
                          <button
                            type="submit"
                            className="btn btn-primary mr-2"
                          >
                            Add Users{" "}
                          </button>
                        </Link>
                      </div>
                    </div>
                  ) : null}
                  {/* <table
                    id="myTable2"
                    className="table-bordered" 
                  ></table> */}

                  <div class="Card_contend">
                    {pending ? (
                      <div className="loader">
                        <RotatingLines
                          visible={true}
                          height="96"
                          width="96"
                          strokeColor="grey"
                          strokeWidth="2"
                          animationDuration="0.75"
                          ariaLabel="rotating-lines-loading"
                        />
                      </div>
                    ) : (
                      <div>
                        {!pending ? (
                          // <div style={{backgroundColor: "white",padding: "15px",marginTop: "10px"}}>
                          <table id="myTable1" className="row-border">
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    color: "#665d5d",
                                  }}
                                >
                                  User Name
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    color: "#665d5d",
                                  }}
                                >
                                  Email
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    color: "#665d5d",
                                  }}
                                >
                                  User Role
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    color: "#665d5d",
                                  }}
                                >
                                  Status
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    color: "#665d5d",
                                  }}
                                >
                                  Created By
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    color: "#665d5d",
                                  }}
                                >
                                  Updated By
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    color: "#665d5d",
                                  }}
                                >
                                  Created On
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    color: "#665d5d",
                                  }}
                                >
                                  Updated On
                                </th>
                                {storeCurrPerm.edit_permission === "1" ||
                                storeCurrPerm.delete_permission === "1" ? (
                                  <th
                                    style={{
                                      fontWeight: "bold",
                                      color: "#665d5d",
                                    }}
                                  >
                                    Action
                                  </th>
                                ) : null}
                              </tr>
                            </thead>
                            <tbody>
                              {items.map((item, index) => (
                                <tr>
                                  <td>{item.username ? item.username : ""}</td>
                                  <td>{item.email ? item.email : ""}</td>
                                  <td>
                                    {item.role_name ? item.role_name : ""}
                                  </td>
                                  <td>{item.status ? item.status : ""}</td>
                                  <td>
                                    {item.created_by ? item.created_by : ""}
                                  </td>
                                  <td>
                                    {item.updated_by ? item.updated_by : ""}
                                  </td>
                                  <td>
                                    {item.created_at ? item.created_at : ""}
                                  </td>
                                  <td>
                                    {item.updated_at ? item.updated_at : ""}
                                  </td>
                                  {storeCurrPerm.edit_permission === "1" ||
                                  storeCurrPerm.delete_permission === "1" ? (
                                    <td>
                                      {item.id &&
                                      storeCurrPerm.edit_permission === "1" ? (
                                        <a
                                          href="#"
                                          data-id={item.id}
                                          value={item.id}
                                          className="edit-role"
                                        >
                                          <i class="mdi mdi-pencil"></i>
                                        </a>
                                      ) : (
                                        ""
                                      )}
                                      {item.id &&
                                      storeCurrPerm.delete_permission ===
                                        "1" ? (
                                        <a
                                          href="#"
                                          data-id={item.id}
                                          value={item.id}
                                          className="delete-role"
                                        >
                                          <i class="mdi mdi-delete"></i>
                                        </a>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  ) : null}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : // </div>
                        null}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Modal */}
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content" style={{ backgroundColor: "white" }}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm Deletion
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={cancelDelete}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ color: "black", fontSize: "14px" }}
              >
                Are you sure you want to delete this user?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={cancelDelete}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Roles;
